import { useMutation } from "react-query";

import http from "infra/http";
import { CategoriaItem } from "../typings";
import { queryClient } from "infra/packages/react-query";
import { useInvalidateQuery } from "infra/packages/react-query";
import { CategoriaFinanceiraItem } from "../typings";
const categoRiaFinanceiraKey = "/v1/categoria-financeira";

const flatten = (array: CategoriaFinanceiraItem[]): CategoriaItem[] =>
  array.flatMap(
    ({ nome, breadcrumb, categoriaFinanceiraPaiId, id, ordem, items }) => [
      {
        nome,
        breadcrumb,
        categoriaFinanceiraPaiId,
        id,
        ordem,
      } as CategoriaItem,
      ...flatten(items || []),
    ]
  );

const comparaCategorias = (i1: CategoriaItem, i2: CategoriaItem) => {
  if (
    i1.id === i2.id &&
    i1.breadcrumb === i2.breadcrumb &&
    i1.categoriaFinanceiraPaiId === i2.categoriaFinanceiraPaiId &&
    i1.nome === i2.nome
  ) {
    return false;
  }
  return true;
};

export default function useChangeFinancialCategory() {
  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();
  const previousData = queryClient.getQueryData<CategoriaFinanceiraItem[]>(
    categoRiaFinanceiraKey
  );

  return useMutation<any, any, any, any>({
    mutationKey: ["/v1/categoria-financeira/multiplas"],
    mutationFn: async (novos: CategoriaFinanceiraItem[]) => {
      // compara nova arvore com anterior e retorna os valores q mudaram para o put
      const arrayAlterado = flatten(novos);
      const arrayInalterado = flatten(previousData!);
      const items = arrayAlterado.filter((alterado) => {
        const comoItemEra = arrayInalterado.find(
          (inalterado) => inalterado.id === alterado.id
        )!;
        return comparaCategorias(comoItemEra, alterado);
      });
      const { data } = await http.put("/v1/categoria-financeira/multiplas", {
        categorias: items,
      });
      return data;
    },
    onSuccess: () => {
      doInvalidateQueryWithStringKey(categoRiaFinanceiraKey);
    },
  });
}
